// 设置语言
export const SET_LANGUAGE = 'SET_LANGUAGE'
// 设置厂商列表
export const SET_FACTORY_LIST = 'SET_FACTORY_LIST';
// 设置厂商表格页码
export const SET_FACTORY_PAGE = 'SET_FACTORY_PAGE';
// 设置省市区列表
export const SET_AREA_LIST = 'SET_AREA_LIST';
// 设置省列表
export const SET_AREA_PROVINCE_LIST = 'SET_AREA_PROVINCE_LIST';
// 设置市列表
export const SET_AREA_CITY_LIST = 'SET_AREA_CITY_LIST';
// 设置区列表
export const SET_AREA_DISTRICT_LIST = 'SET_AREA_DISTRICT_LIST';
// 设置当前选中的省Id,Name
export const SET_AREA_CUR_PROVINCE = 'SET_AREA_CUR_PROVINCE';
// 设置当前选中的市Id,Name
export const SET_AREA_CUR_CITY = 'SET_AREA_CUR_CITY';
// 设置当前选中的区Id,Name
export const SET_AREA_CUR_DISTRICT = 'SET_AREA_CUR_DISTRICT';

// 根据用户id获取用户信息
export const SET_USER_INFO = 'SET_USER_INFO';
// 用户登录
export const SET_USER_LOGIN = 'SET_USER_LOGIN';

// 设置字典列表
export const SET_DICT_LIST = 'SET_DICT_LIST';
// 设置当前选中的字典code,Name
export const SET_CUR_DICT = 'SET_CUR_DICT';

//设置应用列表
export const SET_APPLICATION_LIST = 'SET_APPLICATION_LIST';
//设置应用列表表格页码
export const SET_APPLICATION_PAGE = 'SET_APPLICATION_PAGE';
//管理应用设置当前应用信息
export const SET_APPLICATION_INFO = 'SET_APPLICATION_INFO';
//获取应用下已授权学校列表
export const SET_APPLICATION_AUTHED_SCHOOL_LIST = 'SET_APPLICATIONAUTH_SCHOOL_LIST_INFO';
//设置应用下已授权学校列表表格页码
export const SET_APPLICATION_AUTHED_SCHOOL_PAGE = 'SET_APPLICATION_AUTHED_SCHOOL_PAGE';
//设置授权弹框学校列表
export const SET_APPLICATION_SCHOOL_LIST = 'SET_APPLICATION_SCHOOL_LIST';
//设置授权弹框区平台列表
export const SET_APPLICATION_PLATFORM_LIST = 'SET_APPLICATION_PLATFORM_LIST';
//申请应用下学校授权
export const SET_APPLICATION_SCHOOL_AUTH = 'SET_APPLICATION_SCHOOL_AUTH';
//获取应用下已申请API列表
export const SET_APPLICATION_AUTHED_API_LIST = 'SET_APPLICATION_AUTHED_API_LIST';
//设置应用下已申请API列表表格页码
export const SET_APPLICATION_AUTHED_API_PAGE = 'SET_APPLICATION_AUTHED_API_PAGE';
//设置申请API弹框API列表
export const SET_APPLICATION_API_LIST = 'SET_APPLICATION_API_LIST';
//设置申请API弹框分组列表
export const SET_APPLICATION_API_GROUP_LIST = 'SET_APPLICATION_API_GROUP_LIST';


//设置文档接口分组菜单树
export const SET_DOC_GROUP_LIST = 'SET_DOC_GROUP_LIST';
//设置接口列表
export const SET_DOC_API_LIST = 'SET_DOC_API_LIST';
//设置接口详情信息
export const SET_DOC_API_INFO = 'SET_DOC_API_INFO';
//设置接口参数
export const SET_DOC_API_PARAMS = 'SET_DOC_API_PARAMS';
//设置接口返回参数
export const SET_DOC_API_RETURN_PARAMS = 'SET_DOC_API_RETURN_PARAMS';
//设置上线提示信息
export const SET_UPDATE_CONTENT = 'SET_UPDATE_CONTENT';




// 设置厂商列表
export const SET_ENTERPRISELIST = 'SET_ENTERPRISELIST';

// 设置厂商列表的pageCount
export const SET_ENTERPPAGECOUNT = 'SET_ENTERPPAGECOUNT';

// 设置厂商列表的totalRows
export const SET_ENTERPTOTALROWS = 'SET_ENTERPTOTALROWS';

// 审核厂商
export const SET_AUDITENTERPRISE = 'SET_AUDITENTERPRISE';

// 审核厂商的结果
export const SET_EXAMINEENTERRESULT = 'SET_EXAMINEENTERRESULT';

// 设置应用列表
export const SET_APPLICATIONLIST = 'SET_APPLICATIONLIST';

// 设置应用列表的pageCount
export const SET_APPLICATIONPAGECOUNT = 'SET_APPLICATIONPAGECOUNT';

// 设置应用列表的totalRows
export const SET_APPLICATIONTOTALROWS = 'SET_APPLICATIONTOTALROWS';

// 审核应用
export const SET_AUDITAPPLICATION = 'SET_AUDITAPPLICATION';

// 审核应用的结果
export const SET_EXAMINEAPPLICATIONRESULT = 'SET_EXAMINEAPPLICATIONRESULT';

// 设置api集合
export const SET_APILIST = 'SET_APILIST';

// 选中的api信息
export const SET_APIINFO = 'SET_APIINFO';

// api的授权
export const SET_AUDITAPI = 'SET_AUDITAPI';

// api的授权结果
export const SET_EXAMINEAPIRESULT = 'SET_EXAMINEAPIRESULT';

// 模糊搜索api
export const SET_FUZZYSEARCHAPI = 'SET_FUZZYSEARCHAPI';

// 模糊搜索api的结果
export const SET_APISEARCHARRAY = 'SET_APISEARCHARRAY';

// 模糊搜索api的pagecount
export const SET_APIPAGECOUNT = 'SET_APIPAGECOUNT';

// 模糊搜索api的totalRows
export const SET_APITOTALROWS = 'SET_APITOTALROWS';


// 设置后台登录角色用户信息
export const SET_MANAGE_USER = 'SET_MANAGE_USER';